module.exports = __webpack_public_path__ + "static/media/Oliz.c2fc339a.png";